import { Route, Routes, Navigate } from "react-router-dom";
import { AdminDashboardPage, allowedOptimusUsers, allowedRevenueUsers } from "../pages/adminDashboardPage";
import { Revenue } from "../pages/adminDashboardPage/revenue";
import { AnnualRevenue } from "../pages/adminDashboardPage/revenue/annualRevenue";
import { MonthlyDspRevenue } from "../pages/adminDashboardPage/revenue/monthlyDspRevenue";
import { DspRevenue } from "../pages/adminDashboardPage/revenue/dspRevenue";
import { RequireAuthWrapper } from "../pages/RequireAuthWrapper";
import { AppLayout } from "../components/containers/appLayout/AppLayout";
import { Optimus } from "../pages/adminDashboardPage/optimus/optimusPerformanceGraphing"
import { PermissionsWrapper } from "../pages/PermissionsWrapper";
import { AccountsUserRoleChoices } from "../graphql/generated";
import { userDetailsVar } from "../lib/cache";
import { useReactiveVar } from "@apollo/client";



export const AdminRoutes = () => {

  const currentUser = useReactiveVar(userDetailsVar);

  return (
    <Routes>
      <Route
        path={""}
        element={
          <RequireAuthWrapper>
            <AppLayout pageTitle={"Admin"}>
              <AdminDashboardPage />
            </AppLayout>
          </RequireAuthWrapper>
        }
      > 
      {/* when page initially loads, user is redirected based on permissions - i.e. data team only have access to optimus 
      therefore they will need to be redirected to the optimus page when this page is loaded
      teams who have access to revenue graphing are redirected to this page on inital loading  */}
      <Route
         path={""}
         element={<Navigate to={currentUser && allowedOptimusUsers.includes(currentUser.role) && !allowedRevenueUsers.includes(currentUser.role)? "optimus-campaign" : "revenue-forecast"} replace={true} />}
       />
       
        {/* <Route
                    path={"segment-rotation"}
                    element={
                      <RequireAuthWrapper>
                        <SegmentRotation />
                      </RequireAuthWrapper>
                    }
                  /> */}
        <Route
          path={"revenue-forecast"}
          element={
            <RequireAuthWrapper>
              <Revenue>
                <AnnualRevenue />
              </Revenue>
            </RequireAuthWrapper>
          }
        />
        <Route
          path={"dsp-revenue"}
          element={
            <RequireAuthWrapper>
              <Revenue>
                <DspRevenue />
              </Revenue>
            </RequireAuthWrapper>
          }
        />
        <Route
          path={"monthly-dsp-revenue"}
          element={
            <RequireAuthWrapper>
              <Revenue>
                <MonthlyDspRevenue />
              </Revenue>
            </RequireAuthWrapper>
          }
        />
        <Route
          path={"optimus-campaign"}
          element={
            <RequireAuthWrapper>
                <PermissionsWrapper
                allowedRoles={[AccountsUserRoleChoices.Data, AccountsUserRoleChoices.Tech]}
                mustBeStaff={true}
                >
                <Optimus />
                </PermissionsWrapper>
            </RequireAuthWrapper>
          }
        />
      </Route>
    </Routes>
  );
};

